import { BaseIdentityRequest, BodyIndex, BodyThickness, BustIndex, DimensionsJson, ExtendedShapeJson, Gender, ShapeType, SkinIndex } from 'type/Identity'
import { parseJson } from 'util/json'
import { parseFinite } from 'util/number'

export type Metrics = {
  body?: number
  body_index?: BodyIndex
  body_thickness?: BodyThickness
  bust?: number
  bust_index?: BustIndex
  chest?: number
  gender?: Gender
  height?: number
  hips?: number
  leg?: number
  shape_type?: ShapeType
  shoulders?: number
  skin_index?: SkinIndex
  waist?: number
  weight?: number
}

function mid(range: string | undefined): number | undefined {
  if (!range) return undefined
  const parts = range.split('-')
  const from = parseFinite(parts[0])
  const to = parseFinite(parts[1])
  if (from == null || to == null) return undefined
  return Math.round(Math.abs(to - from) / 2)
}

export function buildMetrics(r: BaseIdentityRequest): Metrics {
  const d = parseJson<DimensionsJson>(r.dimensions)
  const e = parseJson<ExtendedShapeJson>(r.extended_shape)

  const { gender, skin_index } = r
  const { shoulders, chest, waist, hips } = d ?? {}
  const { shape_type, body_thickness } = e ?? {}

  const body_index = r.body
  const bust_index = r.breasts
  const height = d?.height || mid(e?.height) || undefined
  const leg = d?.legLength || e?.legLength || undefined

  return {
    body_index,
    body_thickness,
    bust_index,
    chest,
    gender,
    height,
    hips,
    leg,
    shape_type,
    shoulders,
    skin_index,
    waist,
  }
}
